import React, { useCallback, useEffect, useReducer, useState } from "react"
import type { FiltroCartelas } from "../../../services/cartelasFornecedor"
import { obterCartelas } from "../../../services/cartelasFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { CartelasFornecedorInicial, TAMANHO_PAGINA } from "../models/cartelasFornecedorModel"
import { CartelasFornecedorActionsTypes } from "./cartelasFornecedorActions"
import { CartelasFornecedorContext } from "./CartelasFornecedorContext"
import { cartelasFornecedorReducer } from "./cartelasFornecedorReducer"

export function CartelasFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(cartelasFornecedorReducer, CartelasFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const buscar = useCallback(
        async (filtro: FiltroCartelas, pagina: number) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterCartelas(autorizacao, filtro, pagina, TAMANHO_PAGINA)
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar cartelas")
                } else {
                    setErroCarregamento(null)
                    dispatch({
                        type: CartelasFornecedorActionsTypes.CARREGAR_RESULTADO,
                        payload: {
                            cartelas: response.cartelas,
                            total: response.total,
                            permiteResgateIncompleta: response.permiteResgateIncompleta,
                            isAdmin: response.isAdmin,
                        },
                    })
                    dispatch({
                        type: CartelasFornecedorActionsTypes.MUDAR_PAGINA,
                        payload: { pagina },
                    })
                }
            } catch {
                setErroCarregamento("Erro ao carregar cartelas")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        buscar(CartelasFornecedorInicial.filtro, 0)
    }, [])

    return (
        <CartelasFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento, buscar }}>
            <Loading />
            {children}
        </CartelasFornecedorContext.Provider>
    )
}
